// getRouteUrl.js
let router

// Call this from main.js to define the router once.
export function setRouter(_router) {
  router = _router
}

// Import and use this wherever you need to get route urls. Even works
// outside of components because of `setRouter` above.
export default function getRouteUrl(location) {
  return router.resolve(location).href
}